'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'compact-disc';
var width = 512;
var height = 512;
var aliases = [128191,128192,128440];
var unicode = 'f51f';
var svgPathData = ['M48 256a208 208 0 1 0 416 0 208 208 0 1 0 -416 0zm48 0c0-88.4 71.6-160 160-160 13.3 0 24 10.7 24 24s-10.7 24-24 24c-61.9 0-112 50.1-112 112 0 13.3-10.7 24-24 24s-24-10.7-24-24zm224 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z', 'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM144 256c0-61.9 50.1-112 112-112 13.3 0 24-10.7 24-24s-10.7-24-24-24c-88.4 0-160 71.6-160 160 0 13.3 10.7 24 24 24s24-10.7 24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompactDisc = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;